import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 4 }]],
      [RiskLevel.Medium, [{ lower: 5, upper: 14 }]],
      [RiskLevel.High, [{ lower: 15, upper: 21 }]],
    ]),
  ],
]);

export default referenceRange;
